export { default as ChartService } from './services/chart-service';
export { default as DomEventsBuilder } from './services/dom-events-builder';
export { default as FormatService } from './services/format-service';
export { default as IntlService } from './services/intl-service';
export { default as TemplateService } from './services/template-service';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/services.js
// module id = 208
// module chunks = 29